<template>
  <div>
    <div class="tw-flex tw-items-center tw-justify-between">
      <div class="tw-text-sm tw-font-semibold tw-uppercase">
        Explore jobs to be done
      </div>
      <div class="tw-flex tw-items-center tw-space-x-2">
        <button
          @click="previousSlide"
          class="tw--m-1 tw-rounded-md tw-p-1 tw-transition-colors hover:tw-bg-neutral-50 disabled:tw-cursor-not-allowed disabled:tw-text-neutral-500"
          :disabled="isBeginning"
        >
          <BaseIcon name="arrow-sm-left" class="tw-h-4 tw-w-4" />
        </button>
        <button
          @click="nextSlide"
          class="tw--m-1 tw-rounded-md tw-p-1 tw-transition-colors hover:tw-bg-neutral-50 disabled:tw-cursor-not-allowed disabled:tw-text-neutral-500"
          :disabled="isEnd"
        >
          <BaseIcon name="arrow-sm-right" class="tw-h-4 tw-w-4" />
        </button>
      </div>
    </div>
    <div>
      <BaseCarousel
        ref="carouselElement"
        :breakpoints="{
          1: { slidesPerView: 1 },
          475: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          992: { slidesPerView: 4 },
          1200: { slidesPerView: 5 },
          1536: { slidesPerView: 6 },
        }"
        :slides-data="collections"
        :is-navigation-enabled="false"
      >
        <template #slide="{ slideData }">
          <div class="tw-h-full tw-py-3">
            <InertiaLink :href="slideData.showPath">
              <div
                class="tw-flex tw-h-full tw-items-center tw-space-x-2 tw-rounded-xl tw-bg-white tw-p-1 tw-transition-shadow hover:tw-shadow"
              >
                <div
                  class="tw-grid tw-h-full tw-place-items-center tw-rounded-lg tw-bg-secondary-50 tw-px-2 tw-text-secondary-500"
                >
                  <HashtagIcon class="tw-h-5 tw-w-5" />
                </div>
                <div class="tw-py-2 tw-text-sm tw-font-semibold tw-leading-4">
                  <p class="tw-line-clamp-2">{{ slideData.name }}</p>
                </div>
              </div>
            </InertiaLink>
          </div>
        </template>
      </BaseCarousel>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import BaseCarousel from '@/shared/components/BaseCarousel.vue'
import { usePage } from '@inertiajs/vue3'
import BaseIcon from '@/shared/components/BaseIcon.vue'
import HashtagIcon from '@/assets/images/icons/hashtag.svg'

const carouselElement = ref(null)
const isBeginning = computed(() => carouselElement.value?.isBeginning)
const isEnd = computed(() => carouselElement.value?.isEnd)
const nextSlide = () => carouselElement.value?.nextSlide()
const previousSlide = () => carouselElement.value?.previousSlide()

const page = usePage()
const collections = computed(
  () => page.props.collections as { name: string; showPath: string }[],
)
</script>
